import { render, staticRenderFns } from "./MissionPage.vue?vue&type=template&id=08fbf73a&scoped=true"
import script from "./MissionPage.vue?vue&type=script&lang=ts"
export * from "./MissionPage.vue?vue&type=script&lang=ts"
import style0 from "./MissionPage.vue?vue&type=style&index=0&id=08fbf73a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08fbf73a",
  null
  
)

export default component.exports